import { Icon } from "dash-ui";
import { SUBSCRIPTION_COLORS } from "../../SubscriptionComponents.constants";

interface IProductFeaturesProps {
  featuresList: string[];
}

export default function ProductFeatures({
  featuresList,
}: IProductFeaturesProps) {
  return (
    <div className="flex flex-col gap-3">
      {featuresList.map((feature: string, index: number) => (
        <div className="flex gap-2 items-start" key={index}>
          <div className="flex-shrink-0" style={{ marginTop: "-0.5px" }}>
            <Icon
              color={SUBSCRIPTION_COLORS.featureIcon}
              size={20}
              name="check"
            />
          </div>
          <span
            className="text-sm"
            style={{ color: SUBSCRIPTION_COLORS.featureText }}
          >
            {feature}
          </span>
        </div>
      ))}
    </div>
  );
}
